/* Popup newsletter Carol (sections/popup-newsletter.liquid). Niente librerie.
   - apre il <dialog> solo dopo un'interazione (tocco, clic, tasto, scroll) e
     dopo il ritardo o la percentuale di scroll; da un motore di ricerca conta
     solo il ritardo; mai ai crawler e ai browser automatizzati
   - aspetta se c'e' aperto il carrello, un menu, la ricerca, l'aggiunta rapida,
     un altro dialog, il banner dei cookie, la barra "aggiungi" della scheda su
     telefono o se si sta scrivendo in un campo; se uno di questi si apre col
     popup aperto, il popup si chiude (senza contarlo come "chiuso")
   - telefono: show() non modale, il focus resta dov'era (annuncio polite);
     da 750 px: showModal() e focus sul campo email
   - carica il CSS un attimo prima di aprire
   - localStorage: data della chiusura o "ok" dopo l'iscrizione; se non
     funziona non mostra niente
   - dopo il ricaricamento di Shopify riapre nello stato "grazie" (bottone
     Copia per il codice) o con l'errore (solo se l'invio era partito da qui)
   - nell'editor del tema si apre quando la sezione e' selezionata */
(function () {
  var K = 'pdc_nl';
  var W = window;
  var D = document;
  var ATTESA = 4000;
  var ALTRI =
    'cart-drawer.active, modal-dialog[open], quick-add-modal[open], product-modal[open], ' +
    'header-drawer details[open], details-modal details[open], dialog[open]:not(#pdc-nl)';

  var d = D.getElementById('pdc-nl');
  if (!d || !d.showModal) return;

  var annuncio = D.getElementById('pdc-nl-annuncio');
  var stato = d.dataset.stato;
  var prima = null;
  var osserva = null;

  function telefono() {
    return W.matchMedia('(max-width: 749px)').matches;
  }
  function di(testo) {
    if (!annuncio) return;
    annuncio.textContent = '';
    setTimeout(function () {
      annuncio.textContent = testo;
    }, 60);
  }
  function leggi() {
    try {
      return localStorage.getItem(K) || '';
    } catch (e) {
      return 'x';
    }
  }
  function ricorda(v) {
    try {
      localStorage.setItem(K, v);
    } catch (e) {}
  }
  function segnalibro(metti) {
    try {
      if (metti) return sessionStorage.setItem(K, '1');
      var v = sessionStorage.getItem(K);
      sessionStorage.removeItem(K);
      return v === '1';
    } catch (e) {
      return false;
    }
  }
  function css(cb) {
    var l = D.getElementById('pdc-nl-css');
    if (l) return l.sheet ? cb() : l.addEventListener('load', cb);
    l = D.createElement('link');
    l.id = 'pdc-nl-css';
    l.rel = 'stylesheet';
    l.href = d.dataset.css;
    l.onload = cb;
    D.head.appendChild(l);
  }
  // perAprire: conta anche la barra "aggiungi" fissa della scheda su telefono
  // (a popup aperto invece il pannello sale sopra la barra, vedi CSS)
  function occupato(perAprire) {
    var b = D.body;
    if (/(^|\s)overflow-hidden/.test(b.className)) return true;
    if (D.querySelector(ALTRI)) return true;
    var c = D.getElementById('shopify-pc__banner');
    if (c && c.offsetParent !== null && c.getBoundingClientRect().height > 0) return true;
    if (perAprire && telefono() && b.classList.contains('has-barra-fissa')) return true;
    return false;
  }

  function apri(forza) {
    if (d.open) return;
    css(function () {
      if (d.open || (!forza && occupato(true))) return;
      prima = D.activeElement;
      var campo = d.querySelector('#pdc-nl-email');
      var copia = d.querySelector('[data-copia]');
      var titolo = D.getElementById('pdc-nl-titolo');
      if (telefono()) {
        d.show();
        // show() sposta il focus nel dialog: su telefono lo rimettiamo dov'era,
        // tranne dopo un invio (grazie/errore), quando il visitatore lo aspetta.
        if (stato === 'errore' && campo) campo.focus();
        else if (stato === 'ok' && titolo) titolo.focus({ preventScroll: true });
        else {
          if (prima && prima !== D.body && prima.focus) prima.focus({ preventScroll: true });
          else if (D.activeElement && D.activeElement.blur) D.activeElement.blur();
          di(d.dataset.annuncio || '');
        }
      } else {
        d.showModal();
        if (stato === 'ok') (copia || titolo).focus();
        else if (campo) campo.focus();
      }
      osserva = new MutationObserver(function () {
        if (d.open && !d.matches(':modal') && occupato()) chiudi(true);
      });
      osserva.observe(D.body, { attributes: true, attributeFilter: ['class'], childList: false });
      D.addEventListener('click', clicFuori, true);
    });
  }

  var silenzioso = false;
  function chiudi(senzaRicordare) {
    if (!d.open) return;
    silenzioso = !!senzaRicordare;
    d.close();
  }
  function clicFuori(e) {
    // su desktop un clic sul velo (fuori dalla scatola) chiude
    if (d.open && d.matches(':modal') && e.target === d) chiudi();
  }

  d.addEventListener('close', function () {
    if (osserva) osserva.disconnect();
    D.removeEventListener('click', clicFuori, true);
    if (stato === 'ok') ricorda('ok');
    else if (!silenzioso) ricorda(String(Date.now()));
    silenzioso = false;
    var a = D.activeElement;
    if (prima && prima.isConnected && prima.focus && (!a || a === D.body || d.contains(a))) {
      prima.focus({ preventScroll: true });
    }
  });
  D.addEventListener('keydown', function (e) {
    // Esc anche col pannello non modale (telefono con tastiera), se non c'e'
    // un altro pannello aperto che deve chiudersi lui
    if (e.key === 'Escape' && d.open && !d.matches(':modal') && (d.contains(e.target) || !occupato())) {
      e.preventDefault();
      chiudi();
    }
  });
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-chiudi], [data-copia]') : null;
    if (!t) return;
    if (t.hasAttribute('data-chiudi')) chiudi();
    else copiaCodice(t);
  });

  // Errore del campo email annunciato e visibile (oltre al fumetto del browser)
  var campo = d.querySelector('#pdc-nl-email');
  var errore = D.getElementById('pdc-nl-errore');
  if (campo && errore) {
    campo.addEventListener('invalid', function () {
      campo.setAttribute('aria-invalid', 'true');
      errore.textContent = d.dataset.erroreEmail || '';
      errore.hidden = false;
      errore.setAttribute('role', 'alert');
    });
    campo.addEventListener('input', function () {
      if (campo.validity.valid && campo.getAttribute('aria-invalid')) {
        campo.removeAttribute('aria-invalid');
        errore.hidden = true;
        errore.removeAttribute('role');
      }
    });
  }

  function copiaCodice(b) {
    var codice = d.dataset.codice || '';
    var etichetta = b.querySelector('[data-copia-testo]');
    var testo0 = etichetta ? etichetta.textContent : '';
    function riuscito() {
      if (etichetta) etichetta.textContent = d.dataset.copiato || testo0;
      di(d.dataset.copiatoAnnuncio || '');
      clearTimeout(b._t);
      b._t = setTimeout(function () {
        if (etichetta) etichetta.textContent = testo0;
      }, 2500);
    }
    function ripiego() {
      var ok = false;
      var c = D.getElementById('pdc-nl-codice');
      try {
        var r = D.createRange();
        r.selectNodeContents(c);
        var s = W.getSelection();
        s.removeAllRanges();
        s.addRange(r);
        ok = D.execCommand('copy');
      } catch (e) {}
      if (ok) riuscito();
      else di(d.dataset.copiaErrore || '');
    }
    if (navigator.clipboard && W.isSecureContext) {
      navigator.clipboard.writeText(codice).then(riuscito, ripiego);
    } else ripiego();
  }

  var f = d.querySelector('form');
  if (f) {
    f.addEventListener('submit', function () {
      segnalibro(true);
    });
  }

  if (W.Shopify && W.Shopify.designMode) {
    var mia = function (e) {
      return e.detail && e.detail.sectionId === d.dataset.sezione;
    };
    D.addEventListener('shopify:section:select', function (e) {
      if (mia(e)) apri(true);
    });
    D.addEventListener('shopify:section:load', function (e) {
      if (mia(e)) apri(true);
    });
    D.addEventListener('shopify:section:deselect', function (e) {
      if (mia(e)) chiudi(true);
    });
    return;
  }

  // Crawler e browser automatizzati: mai
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|inspectiontool/i.test(navigator.userAgent)) {
    return;
  }

  var mem = leggi();
  if (mem === 'x') return;

  function quandoLibero() {
    if (occupato(true)) return setTimeout(quandoLibero, ATTESA);
    apri();
  }
  if (stato === 'ok') {
    segnalibro(false);
    ricorda('ok');
    return quandoLibero();
  }
  if (stato === 'errore') {
    if (segnalibro(false)) quandoLibero();
    return;
  }
  if (mem === 'ok') return;
  if (mem && Date.now() - Number(mem) < Number(d.dataset.giorni || 14) * 864e5) return;

  var toccato = false;
  var pronto = false;
  var host = (D.referrer.match(/^https?:\/\/([^/]+)/) || [])[1] || '';
  var daRicerca = /(^|\.)(google|bing|yahoo|duckduckgo|ecosia|qwant|yandex)\./.test(host);
  var quota = daRicerca ? 0 : Number(d.dataset.scroll || 0);

  function prova() {
    if (!toccato || !pronto || d.open) return;
    var a = D.activeElement;
    if ((a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) || D.hidden || occupato(true)) {
      return setTimeout(prova, ATTESA);
    }
    apri();
  }
  function tocco() {
    toccato = true;
    prova();
  }
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(function (ev) {
    W.addEventListener(ev, tocco, { once: true, passive: true });
  });
  setTimeout(function () {
    pronto = true;
    prova();
  }, Number(d.dataset.ritardo || 15) * 1000);
  if (quota > 0) {
    W.addEventListener(
      'scroll',
      function sc() {
        var h = D.documentElement.scrollHeight - W.innerHeight;
        if (h <= 0 || (W.scrollY / h) * 100 >= quota) {
          W.removeEventListener('scroll', sc);
          pronto = true;
          prova();
        }
      },
      { passive: true }
    );
  }
})();
